// Action Types
export const FETCH_OPPORTUNITIES_REQUEST = "FETCH_OPPORTUNITIES_REQUEST";
export const FETCH_OPPORTUNITIES_SUCCESS = "FETCH_OPPORTUNITIES_SUCCESS";
export const FETCH_OPPORTUNITIES_FAILURE = "FETCH_OPPORTUNITIES_FAILURE";

// Action Creators
export const fetchOpportunitiesRequest = ({ clientName,accountName,userId,type}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_OPPORTUNITIES_REQUEST,
      payload: { clientName,accountName,userId,type },
    });
  };
};
export const fetchOpportunitiesSuccess = (data) => ({
  type: FETCH_OPPORTUNITIES_SUCCESS,
  payload: data,
});
export const fetchOpportunitiesFailure = (error) => ({
  type: FETCH_OPPORTUNITIES_FAILURE,
  payload: error,
});


export const updateBookmarkSuccess = (oppId, data) => ({
  type: 'UPDATE_BOOKMARK_SUCCESS',
  payload: { oppId, data },
});




